import React from 'react';
import {  Calendar, FileText, TrendingUp } from 'lucide-react';

const Stats = ({ notes }) => {
  const totalNotes = notes.length;
  const totalWords = notes.reduce((acc, note) => acc + note.content.split(/\s+/).length, 0);

  return (
    <div className="animate-in fade-in duration-500">
      <h1 className="text-3xl font-black mb-8 text-gray-800">Your Analytics</h1>
      
      <div className="grid grid-cols-2 gap-4 mb-8">
        <div className="bg-indigo-600 p-6 rounded-3xl text-white shadow-lg shadow-indigo-100">
          <FileText className="mb-4 opacity-80" size={28} />
          <div className="text-4xl font-black">{totalNotes}</div>
          <p className="text-indigo-100 text-sm font-medium">Total Notes</p>
        </div>

        <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
          <TrendingUp className="text-indigo-600 mb-4" size={28} />
          <div className="text-4xl font-black text-gray-800">{totalWords}</div>
          <p className="text-gray-400 text-sm font-medium">Words Written</p>
        </div>
      </div>

      <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <Calendar className="text-indigo-600" size={20} />
          <h2 className="font-bold text-gray-700">Recent Activity</h2>
        </div>
        
        {notes.slice(0, 3).map((note, idx) => (
          <div key={idx} className="flex items-center justify-between py-3 border-b border-gray-50 last:border-0">
            <div className="text-sm font-semibold text-gray-600">{note.title}</div>
            <div className="text-xs text-gray-400">{note.date}</div>
          </div>
        ))}

        {totalNotes === 0 && (
            <p className="text-center text-gray-400 py-4 text-sm">No data available yet.</p>
        )}
      </div>
    </div>
  );
};

export default Stats;